import React, { useState, useEffect } from "react";
import ContentLoader from "../common/ContentLoader";
import ReviewCard from "./partial/ReviewCard";
import useAxios from "../../hooks/useAxios";
import { KundliPredictionRating } from "../../types/interfaces";

interface ProductReviewProps {
  productId: string	
}
const ReviewsList: React.FC<ProductReviewProps> = ({ productId }) => {
  const axiosInstance = useAxios();
  const [results, setResults] = useState<KundliPredictionRating[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  
  //Single useEffect for all changes
  useEffect(() => {
    getListData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]); // No trigger, prevents double calls

  const getListData = async () => {
    //console.log('getListData function called');
    if (productId) {
      setIsLoading(true);
      try {
        const response: any = await axiosInstance({
          url: "kundli-prediction/get-product-rating",
          method: "GET",
          data: { product_id: productId },
        });
        // console.log('events review', response);
        if (!response.error) {
          setResults(response.data.product_reviews);
        }
      } catch (error: any) {
        console.error("Error in api request:", error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    }
  };

  return (
    <div className={`${isLoading ? "overlay overlay-block" : ""} `}>
        <div className="gap-3">
          {!results || results.length === 0 ? (
            <div className="d-flex align-items-center justify-content-center">
              <span className="fs-1x fw-bold">No Review Found</span>
            </div>
          ) : (
            <ReviewCard reviews={results} />
          )}
        </div>
        {/*Content Loader Start*/}
        {isLoading && <ContentLoader />}
        {/*Content Loader End*/}
    </div>
  );
};

export default ReviewsList;
